import React, {Component} from 'react';
import _ from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import {
  InlineTextBoxField,
  Select,
  Checkbox,
  TextAreaField,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import ReadOnlyDollarSignField from 'app-ui-componentlibrary/dist/go/components/common/ReadOnlyDollarSignField';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';
import {
  displayCostError,
  displayEmployeeError,
  displayError,
  findByRosterId,
} from 'common/requestDetails/utils';
import {
  checkIfValuesAre,
  setTime,
  showDollarAmountWithDollar,
  evaluateOperator,
  compileContent,
} from 'common/utils';
import {
  ADDITIONAL_INFORMATION,
  COST_ITEM_PERIOD_TYPE,
  PAYMENT,
} from 'common/requestDetails/constants.js';
import {HiddenField} from 'go/components/modules/requestDetails/v3/items/shared/HiddenField';
import {DisplayText} from 'go/components/modules/requestDetails/v3/items/shared/DisplayText';
import {StaticText} from 'go/components/modules/requestDetails/v3/items/shared/StaticText';
import {StaticSelect} from 'go/components/modules/requestDetails/v3/items/shared/StaticSelect';
import {Icon} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';

const ConfigTypeToElementMap = {
  checkbox: Checkbox,
  textBoxField: InlineTextBoxField,
  inlineDollarField: InlineDollarField,
  readOnlyDollarSignField: ReadOnlyDollarSignField,
  select: Select,
  radioField: RadioField,
  hidden: HiddenField,
  displayLabel: DisplayText,
  displayText: StaticText,
  displayDollar: ReadOnlyDollarSignField,
  displaySelect: StaticSelect,
  displayCheckbox: Icon,
  textArea: TextAreaField,
};

export const getElementDataPath = (costItemType, name, index, costIndex) => {
  switch (costItemType) {
    case COST_ITEM_PERIOD_TYPE.WHOLE:
      return `cost[0][${index}].${name}`;
    case COST_ITEM_PERIOD_TYPE.YEAR:
      return `cost[${index}][${costIndex ? costIndex : '0'}].${name}`;
    default:
      return name;
  }
};

export class DynamicElement extends Component {
  handleChangeByEvent = (e) => {
    const {conf, costItemType, index, costIndex} = this.props;
    const {toggles} = _.get(this.props.context, 'toggles');
    const noNegativeQuantity = _.includes(toggles, 'noNegativeQuantity');

    if (conf.type !== 'radioField') e.preventDefault();
    let targetVal = e.target.value;
    let resetFields = undefined;
    if (conf.resetFields) {
      resetFields = _.map(conf.resetFields, (field) =>
        getElementDataPath(costItemType, field, index, costIndex)
      );
    }
    if (conf.booleanField) {
      if (_.toLower(targetVal) === 'true') targetVal = true;
      if (_.toLower(targetVal) === 'false') targetVal = false;
    }
    if (conf.numberField) {
      const value = !checkIfValuesAre([null, '', undefined], targetVal) 
      ? (noNegativeQuantity && conf.name == 'quantity' && _.toNumber(targetVal) < 0 ? _.toNumber(-targetVal) : _.toNumber(targetVal)) 
      : targetVal;
      if (!_.isNaN(value)) {
        this.props.handleItemChange(
          getElementDataPath(costItemType, conf.name, index, costIndex),
          value,
          costIndex
        );
      } else {
        this.props.handleItemChange(
          getElementDataPath(costItemType, conf.name, index, costIndex),
          '',
          costIndex
        );
      }
    } else {
      this.props.handleItemChange(
        getElementDataPath(costItemType, conf.name, index, costIndex),
        targetVal,
        costIndex,
        {
          resetFields,
        }
      );
    }
  };

  handleChangeByPair = (name, value) => {
    const {conf, costItemType, index, costIndex} = this.props;
    this.props.handleItemChange(
      getElementDataPath(costItemType, conf.name, index, costIndex),
      value,
      costIndex
    );
  };

  handleBlur = () => {
    const {conf, costItemType, index, costIndex} = this.props;
    this.props.handleBlur(getElementDataPath(costItemType, conf.name, index, costIndex));
  };

  getReadOnlyValue = (conf, cost) => {
    switch (conf.type) {
      case 'displayDollar':
      case 'readOnlyDollarSignField':
      case 'inlineDollarField':
        return showDollarAmountWithDollar(_.get(cost, conf.name, 0));
      case 'checkbox':
      case 'displayCheckbox':
        return _.get(cost, conf.name) ? (
          <Icon name="checkmark" fitted />
        ) : (
          <Icon name="square outline" disabled />
        );
      case 'radioField':
        const radioOptions = _.get(conf, 'props.options');
        const radioValue = _.get(cost, conf.name, conf.value);
        const radioLabel = _.chain(radioOptions)
          .find((option) => option.value === radioValue)
          .get('label', '')
          .value();
        return radioLabel;
      case 'select':
      case 'displaySelect':
        const optionKey = _.get(cost, conf.name, conf.value);
        const options = _.get(conf, 'props.options');
        const option = _.find(options, (selection) => selection.key === optionKey);
        if (typeof option !== 'undefined')
          return option.text ? option.text : option.value;
        else return optionKey;
      default:
        return _.get(cost, conf.name, conf.value);
    }
  };

  getElementDerivedProps = (index, costIndex) => {
    let elementId;
    let elementName;
    let elementErrors = {};

    const {conf, id, validationErrors, validationDirtyMap, costItemType} = this.props;
    if (COST_ITEM_PERIOD_TYPE.WHOLE === costItemType) {
      elementId = `${conf.name}-${id}-${index}`;
      elementName = `${conf.name}-${id}-${index}`;
      elementErrors = displayCostError(
        conf.name,
        validationErrors,
        validationDirtyMap,
        0,
        index
      );
    } else if (COST_ITEM_PERIOD_TYPE.YEAR === costItemType) {
      elementId = `${conf.name}-${id}-${index}${
        !checkIfValuesAre([null, undefined], costIndex) ? `-${costIndex}` : ''
      }`;
      elementName = `${conf.name}-${id}-${index}${
        !checkIfValuesAre([null, undefined], costIndex) ? `-${costIndex}` : ''
      }`;
      elementErrors = displayCostError(
        conf.name,
        validationErrors,
        validationDirtyMap,
        index,
        costIndex ? costIndex : 0
      );
    } else if ('employee' === costItemType) {
      let validationDirtyPath = `${ADDITIONAL_INFORMATION}.${PAYMENT}.${index}.${id}.${conf.name}`;
      elementId = `${conf.name}-${id}-${index}`;
      elementName = `${conf.name}-${id}-${index}`;
      elementErrors = displayEmployeeError(
        conf.validationFieldPath || conf.name,
        validationDirtyPath,
        validationErrors,
        validationDirtyMap,
        id
      );
    } else {
      elementId = `${conf.name}`;
      elementName = `${conf.name}`;
      elementErrors = displayError(
        conf.validationFieldPath || conf.name,
        conf.name,
        validationErrors,
        validationDirtyMap
      );
    }

    return {
      elementId,
      elementName,
      elementErrors,
    };
  };

  render() {
    const {conf, index, cost, costItemType, editable, costIndex} = this.props;

    // Do not render 'hidden' type in view mode
    if (!editable && conf.type === 'hidden') {
      return <></>;
    }

    if(conf.type === 'displaySelect' && _.get(cost, conf.name) === undefined) {
      return <></>;
    }

    if (conf.shouldDisplayRules) {
      let isHidden = !shouldDisplay(
        undefined,
        undefined,
        conf.shouldDisplayRules,
        this.props
      );
      if (isHidden) {
        return <></>;
      }
    }

    const Element = ConfigTypeToElementMap[conf.type];
    const elementDerivedProps = this.getElementDerivedProps(index, costIndex);
    let titleGuidance = conf.guidance;
    if (!titleGuidance) {
      titleGuidance = conf.label;
    }
    if (conf.type == 'textArea') {
      // Prevents duplicate textarea labels, and displays label inline with optional indicator text when present
      // Grabs label from correct location for read only mode
      const isOptional = _.get(conf, 'props.optional');
      if (isOptional) titleGuidance = null;
      if (!editable) titleGuidance = _.get(conf, 'props.label');
    }

    return (
      <div className={conf.className}>
        {titleGuidance && (
          <div className="questionText">{ReactHtmlParser(titleGuidance)}</div>
        )}
        {editable && conf.type !== 'displayCheckbox' ? (
          <Element
            {...conf.props}
            id={elementDerivedProps.elementId}
            value={_.get(cost, conf.name, conf.value)}
            checked={_.get(cost, conf.name)}
            name={elementDerivedProps.elementName}
            path={getElementDataPath(costItemType, conf.name, index, costIndex)}
            handleChange={
              conf.type === 'textBoxField' ||
              conf.type === 'textArea' ||
              conf.type === 'select' ||
              conf.type === 'radioField'
                ? this.handleChangeByEvent
                : this.handleChangeByPair
            }
            handleBlur={this.handleBlur}
            errorMessages={elementDerivedProps.elementErrors.errorMessages}
            displayError={elementDerivedProps.elementErrors.displayError}
          />
        ) : (
          <div>{this.getReadOnlyValue(conf, cost)}</div>
        )}
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    data: state.dynamicComponent.data,
    context: state.dynamicComponent.context,
  };
};

export default connect(mapStateToProps)(DynamicElement);
